import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const VendorNode = memo(({ data, isConnectable }) => {
  const { label, vendorId, hasChildren, isExpanded, rawData } = data;
  
  return (
    <Box
      sx={{
        background: '#2E7D32',
        color: 'white',
        padding: '8px 12px',
        borderRadius: 1,
        minWidth: 160,
        minHeight: 60,
        position: 'relative',
        cursor: hasChildren ? 'pointer' : 'default',
        '&:hover': {
          boxShadow: 2,
        },
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        style={{ background: '#888', border: '2px solid #2E7D32' }}
      />
      
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="caption" sx={{ 
            fontWeight: 'bold', 
            fontSize: '0.7rem',
            opacity: 0.9,
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            VENDOR
          </Typography>
          {label && label !== 'Vendor' && (
            <>
              <Typography variant="caption" sx={{ 
                fontWeight: 'bold', 
                fontSize: '0.7rem',
                opacity: 0.9
              }}>
                -
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
                {label}
              </Typography>
            </>
          )}
          {hasChildren && (
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
              {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </Box>
          )}
        </Box>
        
        <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '0.7rem' }}>
          {vendorId}
        </Typography>
        
        {rawData?.vendor_type && (
          <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '0.7rem', fontWeight: 'medium' }}>
            {rawData.vendor_type}
          </Typography>
        )}
      </Box>
      
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        style={{ background: '#888', border: '2px solid #2E7D32' }}
      />
    </Box>
  );
});

VendorNode.displayName = 'VendorNode';

export default VendorNode; 